import { equals, find } from '@execonline-inc/collections';
import { Menu } from '@headlessui/react';
import clsx from 'clsx';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { SearchParameter, SearchParameters } from '../../../../ListFilter/Types';
import { T } from '../../../../Translations';
import ChevronDown from '../../../Cutesies/ChevronDown';

interface Props {
  searchParameters: SearchParameters;
}

const selectionCount = (searchParameters: SearchParameters) =>
  find((parameter: SearchParameter) => equals(parameter.key, 'owner'), searchParameters)
    .andThen(({ value }) => fromEmpty(value).map((v) => v.split(',')))
    .map((array) => array.length);

function MenuButton({ searchParameters }: Props) {
  return (
    <Menu.Button
      className={clsx(
        'mt-1 block w-48 rounded-md border-1 border-solid',
        'border-gray-300 bg-white px-3 py-2 text-sm font-medium',
      )}
    >
      <div className="flex flex-row justify-between w-full">
        {selectionCount(searchParameters)
          .map((count) => <T kind="Selected: ({{count}})" count={count} />)
          .getOrElse(() => (
            <T kind="All" />
          ))}
        <div className="w-5">
          <ChevronDown />
        </div>
      </div>
    </Menu.Button>
  );
}

export default observer(MenuButton);
